import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=8fa41380&"
import script from "./SectionTitle.vue?vue&type=script&lang=js&"
export * from "./SectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./SectionTitle.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SectionTitle.vue"
export default component.exports